import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {SearchResults} from "./search.results";
import {useIsNarrow} from "./use.narrow";

const findActiveSearchResults = (messages) => {
    for (let i = messages.length - 1; i >= 0; i--) {
        const m = messages[i];
        if (m.type === 'thinking') continue;
        if (m.sender === 'client') return null;
        if (m.sender === 'bot') {
            return m.searchResults && m.searchResults.length > 0 ? m.searchResults : null;
        }
    }
    return null;
};

export const SearchResultsPanel = () => {
    const messages = useSelector((state) => state.chat.messages);
    const isNarrow = useIsNarrow();

    const lastSearchResults = useMemo(() => findActiveSearchResults(messages), [messages]);

    if (!lastSearchResults || isNarrow) {
        return null;
    }

    return (
        <div className="sb-chat--search-sidebar">
            <SearchResults results={lastSearchResults} defaultOpen={true} />
        </div>
    );
};

export const SearchResultsDropdown = () => {
    const messages = useSelector((state) => state.chat.messages);

    const lastSearchResults = useMemo(() => findActiveSearchResults(messages), [messages]);

    if (!lastSearchResults) return null;

    return (
        <div className="sb-search-results--bar">
            <SearchResults results={lastSearchResults} dropdown={true} />
        </div>
    );
};
